import styled from "styled-components";

export const SCreateProjectModalNavStepsSeparator = styled.div`
  width: 16px;
  height: 1px;
  background-color: var(--ui-03);
`;
